



































































import {Component} from 'vue-property-decorator';
import {mixins} from 'vue-class-component';
import SnackbarMixin from '@/mixins/SnackbarMixin';
import LoadingMixin from '@/mixins/LoadingMixin';
import DialogUploadCertificate from '@/views/Cartification/index.vue';
import {swalSuccess, swalWarning} from '@/plugins/swal';
import FileInputField from '@/components/Form/FileInputField.vue';

@Component({
  components: {DialogUploadCertificate, FileInputField},
})
export default class UploadIndex extends mixins(LoadingMixin, SnackbarMixin) {
  $refs!: {
    uploader: HTMLFormElement;
  };

  dialog = false;
  listItems = [];
  title = '';
  loadingdata = false;
  search = '';
  idExclude: any = [];
  tmpFile: any = null;
  isLoading = false;
  form: any = {
    foto_badan: null,
    foto_setengah_badan: null,
    ktp: null,
    cv: null,
    ijazah: null,
    transkrip: null,
    sim_a: null,
    sim_b: null,
    sim_c: null,
    sim_b1: null,
    sim_b2: null,
    sim_b1_umum: null,
    sim_b2_umum: null,
  };
  arrayField = [
    {
      label: 'Foto Full Body',
      key: 'foto_badan',
      rule: 'required',
    },
    {
      label: 'Pas Foto',
      key: 'foto_setengah_badan',
      rule: 'required',
    },
    {
      label: 'KTP',
      key: 'ktp',
      rule: 'required',
    },
    {
      label: 'CV',
      key: 'cv',
      rule: 'required',
    },
    {
      label: 'Ijazah',
      key: 'ijazah',
      rule: 'required',
    },
    {
      label: 'Transkrip',
      key: 'transkrip',
      rule: 'required',
    },
    {
      label: 'SIM A',
      key: 'sim_a',
      rule: '',
    },
    {
      label: 'SIM B',
      key: 'sim_b',
      rule: '',
    },
    {
      label: 'SIM C',
      key: 'sim_c',
      rule: '',
    },
    {
      label: 'SIM B1',
      key: 'sim_b1',
      rule: '',
    },
    {
      label: 'SIM B2',
      key: 'sim_b2',
      rule: '',
    },
    {
      label: 'SIM B1 Umum',
      key: 'sim_b1_umum',
      rule: '',
    },
    {
      label: 'SIM B2 Umum',
      key: 'sim_b2_umum',
      rule: '',
    },
  ];
  view: any = {
    foto_badan: '',
    foto_setengah_badan: '',
    ktp: '',
    cv: '',
    ijazah: '',
    transkrip: '',
    sim_a: '',
    sim_b: '',
    sim_c: '',
    sim_b1: '',
    sim_b2: '',
    sim_b1_umum: '',
    sim_b2_umum: '',
  };

  async mounted() {
    await this.fecthUserData();
  }

  async fecthUserData() {
    try {
      this.startLoading('detail');
      const res = await this.$store.dispatch('users/getUserFile');
      this.finishLoading('detail');
      if (res.status === 200 && res.data.data !== null) {
        this.view = res.data.data;
      }
    } catch (e) {
      this.catchError(e);
    }
  }

  get profile() {
    return JSON.parse(localStorage.getItem('USER') || '{}');
  }

  async onFileChanged(e: any, title: string) {
    this.tmpFile = e;

    // Daftar tipe file yang diizinkan
    const validImageTypes = [
      'image/jpeg',
      'image/png',
      'application/pdf',
      'image/jpg',
    ];

    // Cek tipe file
    if (this.tmpFile && !validImageTypes.includes(this.tmpFile.type)) {
      swalWarning.fire({
        title: 'Error!',
        text:
          'Only image files (JPG, PNG, JPEG) or PDF are allowed. Please upload a valid file.',
        icon: 'error',
        confirmButtonText: 'OK',
      });

      // Kosongkan input file
      e.target.value = null; // Ini akan mereset file input
      this.tmpFile = null;
      return;
    }

    // Cek ukuran file dalam bytes, 1MB = 1048576 bytes
    if (this.tmpFile && this.tmpFile.size > 1048576) {
      swalWarning.fire({
        title: 'Error!',
        text: 'File size exceeds 1MB. Please upload a smaller file.',
        icon: 'error',
        confirmButtonText: 'OK',
      });

      // Kosongkan input file
      e.target.value = null; // Ini akan mereset file input
      this.tmpFile = null;
      return;
    }

    // Jika file valid, lanjutkan proses upload
    if (typeof this.tmpFile === 'object') {
      try {
        const formData = new FormData();
        formData.append('files', this.tmpFile);
        formData.append('tags', title + '-' + this.profile.nik);
        formData.append('type', 'local');

        this.isLoading = true;
        const res = await this.$store.dispatch('users/uploadFile', formData);
        if (res.status === 200) {
          this.tmpFile = null;
          this.updateData(res.data, title);
        }
      } catch (e) {
        this.tmpFile = null;
        this.isLoading = false;
        this.catchError(e);
      }
    }
  }

  async updateData(respondata: any, title: string) {
    try {
      this.isLoading = true;
      const form = {
        url: respondata[0].url,
        title: title,
      };
      const res = await this.$store.dispatch('users/saveUrlFIle', form);
      if (res.status === 200) {
        swalSuccess.fire({
          title: 'Success!',
          text: `File ${title} Success to Upload`,
        });
        this.fecthUserData();
      }
      this.isLoading = false;
    } catch (e) {
      this.tmpFile = null;
      this.isLoading = false;
      this.catchError(e);
    }
  }

  async onSubmit() {
    const requiredFields = this.arrayField.filter(
      item => item.rule === 'required',
    );

    const missingFiles = requiredFields.filter(item => !this.view[item.key]);

    if (missingFiles.length > 0) {
      swalWarning.fire({
        title: 'Error!',
        text: 'Please upload all required files before proceeding.',
        icon: 'error',
        confirmButtonText: 'OK',
      });
      return;
    }

    this.$router.push('skill');
  }

  handleFileImport() {
    this.isLoading = true;

    // After obtaining the focus when closing the FilePicker, return the button state to normal
    window.addEventListener(
      'focus',
      () => {
        this.isLoading = false;
      },
      {once: true},
    );

    // Trigger click on the FileInput
    this.$refs.uploader.click();
  }
  beforeRouteLeave(to: any, from: any, next: any) {
    const requiredFields = this.arrayField.filter(
      item => item.rule === 'required',
    );

    const missingFiles = requiredFields.filter(item => !this.view[item.key]);
    if (missingFiles.length > 0) {
      swalWarning.fire({
        title: 'Error!',
        text: 'Please upload all required files before leaving the page.',
        icon: 'error',
        confirmButtonText: 'OK',
      });
      return;
    } else {
      next();
    }
  }
}
